import React from "react";
import "./styles.css";
import CustomizedProgressBars from "./ProgressBar";

function Skills() {
    return(
    <section className="skills" id="skills">
    <h3 className="heading">All of my <span>Skills</span> and <span>Experties</span></h3>
    <CustomizedProgressBars />
    </section>

    )
}

export default Skills;